export default __webpack_public_path__ + "static/media/rollingQueen.81652914.jpg";